import { Construction } from "lucide-react";

export default function EstimatingStub({ tabKey, title, subtitle }) {
  return (
    <div className="page-body" data-testid={`estimating-stub-${tabKey}`}>

      <div className="mt-10 mx-auto max-w-xl rounded-xl border border-slate-200 bg-white p-10 flex flex-col items-center text-center">
        <div className="h-12 w-12 rounded-full bg-blue-50 flex items-center justify-center">
          <Construction className="h-6 w-6 text-blue-500" />
        </div>
        <h2 className="mt-4 text-lg font-semibold text-slate-800 dark:text-slate-100">Coming soon</h2>
        <p className="mt-2 text-sm text-slate-500 max-w-sm">
          This is part of the new Estimating suite. We'll build it out in an upcoming phase.
        </p>
      </div>
    </div>
  );
}
